import React from 'react'
import Head from 'next/head'

import { BackToTop, BreadcrumbContainer } from '@srca-b2b/kp5-ui-common'
import classNames from 'classnames'
import { Container } from 'react-bootstrap'
import ModalGlobalAgreement from '../ModalGlobalAgreement/ModalGlobalAgreement'
import { DeviceWidthProvider } from '@srca-b2b/kp5-ui-common/context/DeviceWidthContext'
import styles from './Layout.module.scss'
import Footer from '../Footer/Footer'

const Layout = ({
  id,
  breadcrumb,
  children,
  className,
  containerClassName,
  title = 'Samsung Knox | Secure mobile platform and solutions',
  withFooter = true,
  productParam = null
}) => {
  return (
    <DeviceWidthProvider>
      <div
        id={id}
        className={classNames('content-wrapper', className, 'marketing', styles.contentWrapper)}
      >
        <Head>
          <title>{title}</title>
          <meta charSet="utf-8" />
          <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        </Head>
        <header>
          <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
          <ModalGlobalAgreement />
        </header>
        <main>
          <Container className={classNames(styles.containerWrapper, containerClassName)}>
            {breadcrumb && (
              <BreadcrumbContainer className="mb-4 pb-2">{breadcrumb}</BreadcrumbContainer>
            )}
            {children}
          </Container>
          <BackToTop customLabel={<span className={styles.backToTop}>Back to top</span>} />
        </main>
        {withFooter && <Footer productParam={productParam} />}
      </div>
    </DeviceWidthProvider>
  )
}

export default Layout
